import * as Yup from 'yup'
import { TFunction } from 'i18next'

export const getValidationSchema = (
  t: TFunction<'messages'>,
  requiresMessageCategory: boolean
) =>
  Yup.object({
    subject: Yup.string()
      .trim()
      .max(200)
      .required(t('validation.subjectRequired')),
    message: Yup.string()
      .trim()
      .max(3000, t('validation.messageMaxLength'))
      .required(t('validation.messageRequired')),
    attachments: Yup.array().of(Yup.mixed()),
    messageCategoryId: requiresMessageCategory
      ? Yup.string().required(t('validation.categoryRequired'))
      : Yup.string(),
  })
